import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
import { OrderSummaryCard } from "../../components/OrderSummaryCard";
export var SelfServeContentWrapper = function SelfServeContentWrapper(_ref) {
  var leftSection = _ref.leftSection;
  var _useViewport = useViewport(),
    isTabletAndAbove = _useViewport.isTabletAndAbove;
  return /*#__PURE__*/React.createElement(Row, {
    "data-test-id": "self-serve-surface-wrapper"
  }, /*#__PURE__*/React.createElement(LeftPanelWrapper, {
    "data-test-id": "left-panel-wrapper"
  }, /*#__PURE__*/React.createElement(LeftPanelInnerWrapper, {
    "data-test-id": "left-panel-inner-wrapper"
  }, leftSection)), isTabletAndAbove ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OrderSummaryCard, null), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }))) : null);
};
var LeftPanelWrapper = styled.div.withConfig({
  displayName: "SelfServeContentWrapper__LeftPanelWrapper"
})(["width:100%;padding:", ";", "{padding:", ";}background-color:", ";min-height:75vh;"], getSpacing("4x"), responsiveMediaQueries.mobile, getSpacing("2x"), Core.surface.inverse);
var LeftPanelInnerWrapper = styled.div.withConfig({
  displayName: "SelfServeContentWrapper__LeftPanelInnerWrapper"
})(["", "{min-width:0px;}width:100%;"], responsiveMediaQueries.mobile);